export const READ_PLAN_EVENTS_LIST = `READ_PLAN_EVENTS_LIST`
export const READ_PLAN_EVENTS_LIST_SUCCEEDED = `READ_PLAN_EVENTS_LIST_SUCCEEDED`
export const READ_PLAN_EVENTS_LIST_FAILED = `READ_PLAN_EVENTS_LIST_FAILED`
